var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { class: _vm.asCard ? "card-item" : "" }, [
      _c("div", { staticClass: "card-content columns is-multiline" }, [
        _c("div", { staticClass: "column has-text-centered is-full" }, [
          _vm.icon
            ? _c("img", {
                staticClass: "icono",
                attrs: { src: require(`../assets/img/${_vm.icon}`) },
              })
            : _vm._e(),
        ]),
        _c("div", { staticClass: "column has-text-centered is-full" }, [
          _vm._v(" " + _vm._s(_vm.message) + " "),
        ]),
        !!_vm.$slots.default
          ? _c(
              "div",
              { staticClass: "column has-text-centered is-full" },
              [_vm._t("default")],
              2
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }